import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDRqrIHm1onWyhEDzrQxmDWB1yTzv2tkaY",
  authDomain: "www.trackthrough.com",
  projectId: "followthrough-f677d",
  storageBucket: "followthrough-f677d.firebasestorage.app",
  messagingSenderId: "953595942105",
  appId: "1:953595942105:web:fa5c8b9c03122d64a6dac8"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export default app;
